// extracted by mini-css-extract-plugin
export default {"miniBoxWrap":"BoxScore_miniBoxWrap__px9VL","bothTeams":"BoxScore_bothTeams__VIgaR","team":"BoxScore_team__WF9ib"};